import { GAME_TYPE } from 'constants/enums/GameTypeEnum'
import { OverridedMixpanel } from 'mixpanel-browser'

/**
 * Map gameTypeId (1-9) to facilitation technique name
 * Looks up GAME_TYPE by matching `value` property, returns `label`
 */
export const getFacilitationTechnique = (gameTypeId: number): string => {
	const gameType = Object.values(GAME_TYPE).find(
		(g) => g.value === gameTypeId
	)
	return gameType?.label ?? 'Unknown Game'
}

/**
 * Check if user is Slalom based on email domain
 */
export const isSlalomUser = (email: string | undefined | null): boolean => {
	return email?.toLowerCase().endsWith('@slalom.com') ?? false
}

interface SetUserPropertiesParams {
	email: string | undefined
	mixpanel: OverridedMixpanel | undefined
}

/**
 * Set user profile properties on identification
 * Note: Email and name are intentionally not stored in Mixpanel for privacy reasons
 */
export const setUserProperties = ({
	mixpanel,
	email,
}: SetUserPropertiesParams): void => {
	if (!mixpanel) return

	mixpanel.people.set({
		isSlalom: isSlalomUser(email),
	})
}
